import { createSelector } from 'reselect'
import { IRootState } from '../reducer'

export const isLoading = (state: IRootState) => state.clientInfo.loadingArray.length > 0

export const clients = (state: IRootState) => state.clientInfo.clients

export const clientInfo = (state: IRootState) => state.clientInfo.clientInfo

export const RMUsers = (state: IRootState) => state.clientInfo.RMUsers

export const managers = (state: IRootState) => state.clientInfo.managers

export const accountActivity = (state: IRootState) => state.clientInfo.accountActivity
export const accountActivityDateRange = (state: IRootState) =>
  state.clientInfo.accountActivityDateRange

export const complianceStatusLegal = (state: IRootState) => state.clientInfo.complianceStatusLegal

export const complianceStatusFinancials = (state: IRootState) =>
  state.clientInfo.complianceStatusFinancials

export const complianceEntityDetails = (state: IRootState) =>
  state.clientInfo.complianceEntityDetails

export const inventoryLocations = (state: IRootState) => state.clientInfo.inventoryLocations

export const fundingRequest = (state: IRootState) => state.clientInfo.fundingRequest

export const clientsAggregation = (state: IRootState) => state.clientInfo.clientsAggregation

export const dashboardMetrics = (state: IRootState) => state.clientInfo.dashboardMetrics

export const clientId = createSelector(clientInfo, (client) => client?.id)

export const overadvances = (state: IRootState) => state.clientInfo.overadvances

export const complianceData = (state: IRootState) => state.clientInfo.complianceData

export const complianceSummaryMetrics = (state: IRootState) =>
  state.clientInfo.complianceSummaryMetrics

export const complianceAudit = (state: IRootState) => state.clientInfo.complianceAudit

export const termLoans = (state: IRootState) => state.clientInfo.termLoans

export const inventoryEligibilityData = (state: IRootState) =>
  state.clientInfo.inventoryEligibilityData

export const eligibleFields = (state: IRootState) => state.clientInfo.fields

export const customRules = (state: IRootState) => state.clientInfo.customRules

export const customRulesLabels = (state: IRootState) => state.clientInfo.customRulesLabels

export const customRulesValues = (state: IRootState) => state.clientInfo.customRulesValues

export const amendmentsData = (state: IRootState) => state.clientInfo.amendmentsData

export const arEligibilityData = (state: IRootState) => state.clientInfo.arEligibilityData

export const apEligibilityData = (state: IRootState) => state.clientInfo.apEligibilityData

export const financialsReports = (state: IRootState) => state.clientInfo.financialsReports

export const riskRatings = (state: IRootState) => state.clientInfo.riskRatings

export const clientBBCsList = (state: IRootState) => state.clientInfo.clientBBCsList

export const riskRatingDetails = (state: IRootState) => state.clientInfo.riskRatingDetails
export const riskRatingDetailsChart = (state: IRootState) => state.clientInfo.riskRatingDetailsChart
export const riskRatingDetailsNoFilters = (state: IRootState) =>
  state.clientInfo.riskRatingDetailsNoFilters

export const inventoryHealth = (state: IRootState) => state.clientInfo.inventoryHealth

export const cashFlowInfo = (state: IRootState) => state.clientInfo.cashFlowInfo

export const customers = (state: IRootState) => state.clientInfo.customers

export const refreshCount = (state: IRootState) => state.clientInfo.refreshCount

export const accountActivityGraph = (state: IRootState) => state.clientInfo.accountActivityGraph

export const banners = (state: IRootState) => state.clientInfo.banners

export const loanLedger = (state: IRootState) => state.clientInfo.loanLedger

export const stressCase = (state: IRootState) => state.clientInfo.stressCase

export const collectionsReconciliation = (state: IRootState) =>
  state.clientInfo.collectionsReconciliation

export const collectionsReconciliationOptions = (state: IRootState) =>
  state.clientInfo.collectionsReconciliationOptions

export const customerCollections = (state: IRootState) => state.clientInfo.customerCollections

export const salesChannelDistribution = (state: IRootState) =>
  state.clientInfo.salesChannelDistribution

export const salesChannelDistributionOptions = (state: IRootState) =>
  state.clientInfo.salesChannelDistributionOptions

export const arLedgerActivity = (state: IRootState) => state.clientInfo.arLedgerActivity

export const customerInvoicingVsCollections = (state: IRootState) =>
  state.clientInfo.customerInvoicingVsCollections

export const pendingCashDominion = (state: IRootState) => state.clientInfo.pendingCashDominion

export const allPendingCashDominion = (state: IRootState) => state.clientInfo.allPendingCashDominion

export const financialsComparison = (state: IRootState) => state.clientInfo.financialsComparison

export const checkAliases = (state: IRootState) => state.clientInfo.checkAliases

export const termLoansOveradvances = (state: IRootState) => state.clientInfo.termLoansOveradvances

export const clientOveradvances = (state: IRootState) => state.clientInfo.clientOveradvances

export const portfolioBankTransactionsRaw = (state: IRootState) =>
  state.clientInfo.portfolioBankTransactionsRaw
export const masterInvoiceData = (state: IRootState) => state.clientInfo.masterInvoiceData

export const masterInvoicesData = (state: IRootState) => state.clientInfo.masterInvoicesData

export const masterInvoiceBbcHistory = (state: IRootState) =>
  state.clientInfo.masterInvoiceBbcHistory

export const interestRateTiers = (state: IRootState) =>
  state.clientInfo.interestRateTiers?.data?.tiers ?? []

export const masterInvoicePaymentActivity = (state: IRootState) =>
  state.clientInfo.masterInvoicePaymentActivity
